export default {
  init() {
    return {
      showInitial: true
    };
  },

  toggleShowInitial(moduleState, payload) {
    return Object.assign({}, moduleState, {showInitial: payload});
  }
};



// WEBPACK FOOTER //
// ./home/en-US/js/create-shortcut-pc-popup/sdo/mutations.js